module.exports = __webpack_public_path__ + "https://gloprocessor.com/ment/img/Slice 18@2x.80c0c2e5.png";